module.exports = __webpack_public_path__ + "img/vip-banner-bg.ec2fb849.png";